import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  // Expected on the trigger element:
  //   data-asset-preview-url-value="..."
  //   data-asset-preview-type-value="image" | "video"
  //   data-action="click->asset-preview#open"
  static values = { url: String, type: String };

  open() {
    if (!this.urlValue || !this.typeValue) return;
    this.dispatch("open", {
      prefix: "preview-modal",
      target: window,
      detail: { url: this.urlValue, type: this.typeValue },
    });
  }
}
